import { SavedSearchName } from '@aibees/elephant/components';
import { SearchBarFilter } from '@aibees/elephant/components/search-bar-filter';
import { TableLabelType } from '@aibees/elephant/components/table-label-type';
import { SavedSearchTypesFilter } from '@aibees/elephant/feature/saved-search-table/filters/saved-search-types-filter';
import { ElephantPresetType, SearchBrowseParams } from '@aibees/elephant/types';
import {
  DateTime,
  TableCellTypography,
  TextEllipsis,
  UserShortName,
} from '@aibees/shared/components';
import { ParsedPreset } from '@aibees/shared/definition';
import { AdvanceTableConfig } from '@aibees/shared/features';
import { useBrowsePresetApi } from '@aibees/shared/api';
import { DATE_FORMAT_YYYY_MM_DD_hh_mm_a } from '@aibees/shared/utils';
import { SaveSearchTableAction } from './actions/save-search-table-action';
import * as SX from './sx';

export const config: AdvanceTableConfig<ParsedPreset<SearchBrowseParams>> = {
  columns: [
    {
      id: 'name',
      label: 'Name',
      sortable: true,
      width: 132,
      render: (_, v) => <SavedSearchName value={v} showAsLink />,
    },
    {
      id: 'type',
      label: 'Type',
      sortable: 'type',
      width: 96,
      render: (_, v) => (
        <TableLabelType
          isCompany={v.type === ElephantPresetType.COMPANY_SAVED_SEARCH}
        />
      ),
    },
    {
      id: 'user',
      label: 'Team',
      sortable: true,
      width: 96,
      render: (_, v) => (
        <TextEllipsis>
          <TableCellTypography
            item={<UserShortName user={v.workspace.user} />}
          />
        </TextEllipsis>
      ),
    },
    {
      id: 'modified',
      label: 'Last Modified',
      sortable: true,
      width: 114,
      render: (v, d) => (
        <DateTime
          value={v ?? d.modified}
          format={DATE_FORMAT_YYYY_MM_DD_hh_mm_a}
        />
      ),
    },
  ],
  actions: [SaveSearchTableAction],
  browseApi: useBrowsePresetApi,
  initialFilters: {
    type: `${ElephantPresetType.COMPANY_SAVED_SEARCH},${ElephantPresetType.PEOPLE_SAVED_SEARCH}`,
  },
  filters: [SearchBarFilter, SavedSearchTypesFilter],
  actionsConfig: {
    label: 'Action',
    minWidth: '10%',
    align: 'center',
    sx: { display: 'flex', justifyContent: 'center' },
  },
  stickyHeader: true,
  defaultOrderBy: 'modified',
  prependSortingFields: { favorite: 'desc' },
  hideColumnsOnNoData: true,
  showTablePrependOnNotFound: true,
  emptyProps: {
    emptyIcon: 'bookmark',
    emptyIconWrapperSX: SX.emptyIconWrapper,
    titleSx: { fontSize: 14 },
    iconSize: 28,
  },
  hideResetFilters: true,
  cellSx: { px: 0.5, py: 1 },
  bordered: 'solid',
  rowsPerPageOptions: [5],
  showJumpToPage: false,
  showPageSelector: false,
  filtersSx: { flexDirection: 'row !important' },
};
